import * as React from "react";
import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import { cn } from "@/utils";

const iconContainerVariants = cva("flex items-center justify-center", {
  variants: {
    variant: {
      primary:
        "aspect-square size-8 rounded-lg bg-sidebar-primary text-sidebar-primary-foreground",
      bordered: "size-6 rounded-sm border",
      borderedBg: "size-6 rounded-md border bg-background",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});

export interface IconContainerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof iconContainerVariants> {}

function IconContainer({
  className,
  variant,
  children,
  ...props
}: IconContainerProps) {
  return (
    <div
      className={cn(iconContainerVariants({ variant }), className)}
      {...props}
    >
      {children}
    </div>
  );
}

export { IconContainer, iconContainerVariants };
